import { mainText } from 'aegisv2/styles/colors';
import colors from 'crehana-ui/styles/colors';

export default {
  colors: {
    mainText,
    main: '#0099ff',
    mainHover: '#0066ff',
    buy: '#ff0249',
    buyHover: '#ff0249',
    filter: '#7fcbff',
    green: '#35df86',
    ...colors,
  },
  styles: {
    shadow: 'box-shadow: 0 15px 30px rgba(0,0,0,.1);',
    shadowHover: 'box-shadow: 0 14px 56px -20px rgba(0,0,0,.64);',
  },
  media: {
    laptop: '1140px',
  },
};
